// src/components/ProtectedOutlet.jsx
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../api/client";

export default function ProtectedOutlet() {
  const [loading, setLoading] = useState(true);
  const [hasToken, setHasToken] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      setHasToken(false);
      setLoading(false);
      return;
    }

    setHasToken(true);

    const existingUser = localStorage.getItem("user");
    if (existingUser) {
      setLoading(false);
      return;
    }

    api
      .get("/users/me")
      .then((res) => {
        console.log("[ProtectedOutlet] /users/me ->", res.data);
        localStorage.setItem("user", JSON.stringify(res.data));

        if (res.data?.email) {
          localStorage.setItem("last_login_email", res.data.email);
        }
      })
      .catch((err) => {
        console.error("[ProtectedOutlet] error /users/me:", err);
        const status = err?.response?.status;
        localStorage.removeItem("access_token");
        localStorage.removeItem("user");

        // Deactivated user → show message on login page
        if (status === 400 || status === 403) {
          const detail = err?.response?.data?.detail || "";
          if (detail.toLowerCase().includes("inactive") || detail.toLowerCase().includes("deactivated")) {
            localStorage.setItem("login_error", "Your account has been deactivated. Contact admin to reactivate.");
          }
        }
        setHasToken(false);
      })
      .finally(() => setLoading(false));
  }, []);

  if (!hasToken && !loading) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (loading) {
    return <div className="loading-shell">Loading SOW Analyzer…</div>;
  }

  return <Outlet />;
}
